module.exports = __webpack_public_path__ + "static/img/75a5.240fe1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/75a5.jpg
// module id = ukVW
// module chunks = 1